<style lang="sass" scoped>
.order-pay
    padding: 20px
    .pay-inter
        height: 40px
        line-height: 40px
        background: rgba(255,57,115,.1)
        color: #666
        text-align: center
        border-radius: 4px
        font-size: 16px
        span
            color: #FF3973
            font-weight: bold
            margin: 0 5px
    .pay-info
        padding: 20px
        text-align: center
        line-height: 1
        border-bottom: 1px solid #e9e9e9
        font-weight: 600
        font-size: 18px
        .left-right
            font-size: 14px
            margin: 20px 0 10px
    .pay-btm
        margin-top: 30px
        .pay-main
            border: 1px solid #e9e9e9
            border-radius: 0 4px 4px 4px
            padding: 20px
            .fee
                padding: 20px
                border: 2px solid #6296FF
                border-radius: 4px
                .all-fee, .fr
                    display: inline-block
                    margin-left: 20px
                    font-size: 16px
                    >span
                        margin-left: 5px
                        &.color
                            color: #FF7413
                    span
                        font-weight: 800
                        font-size: 14px
                        &.big
                            font-size: 20px

                .radio
                    position: relative
                    top: 5px

            .pay
                margin-top: 20px
                font-size: 18px
                .pswd-box
                    margin-top: 10px
                    width: 363px
                    position: relative
                    .no-click-cover
                        position: absolute
                        width: 100%
                        height: 60px
                        z-index: 1
                    .input
                        border: 1px solid #e9e9e9
                        width: 100%
                        height: 60px
                        line-height: 60px
                        position: relative
                        border-radius: 4px
                        .box
                            display: inline-block
                            width: 60px
                            height: 58px
                            border: 1px solid #fff
                            position: relative
                            &.cur
                                border: 1px solid #6296FF
                                .line
                                    background: #6296FF
                            .line
                                position: absolute
                                top: 14px
                                right: -1px
                                width: 1px
                                height: 30px
                                background: #e9e9e9
                        input
                            width: 58px
                            height: 100%
                            // margin-top: 15px
                            font-size: 30px
                            border: none
                            // border-right: 1px solid #e9e9e9
                            text-align: center
                            &:nth-of-type(6)
                                border-right: none

                    .pswd-btm
                        font-size: 14px
                        color: #999
                        margin-top: 10px
                        .fr
                            color: #6296FF
                            cursor: pointer
                            
            .submit-btn
                margin: 30px 0

.fix-recharge
    .c
        text-align: center
        font-size: 16px
    img
        width: 60px
        margin-top: 25px
        margin-bottom: 10px
</style>

<template lang="pug">
main-right(:title="pageTitle")
    .order-pay
        .part-title 在线支付
        .pay-inter 如果在
            span {{leftTime}}
            | 内您无法完成支付，系统会将您的订单取消。
        .pay-info
            div 您的订单已成功，赶快去付款吧~
            div
                .left-right 您的订单号:
                    span {{orderInfo.orderCode}}
                .left-right 应付金额:
                    span(v-if="useFree") 0
                    span(v-else) {{orderInfo.amount ? orderInfo.amount.toFixed(2) : 0}}元
                .left-right.no-br 支付方式:
                    span(v-if="useFree") 会员权益
                    span(v-else) 账户余额

        .pay-btm
            .gg-tab.cur 余额支付
            .pay-main
                .fee
                    .radio
                        .radio-inner
                    template(v-if="useFree")
                        .all-fee 会员免费点位剩余
                            span.Akrobat-ExtraBold {{vipPointRemain}}个
                        .fr 支付
                            span.color.Akrobat-ExtraBold {{orderInfo.vipReduce || 0}}个
                    template(v-else)
                        .all-fee 账户余额
                            span.Akrobat-ExtraBold ￥
                                span.big {{normalFee | fmtFee}}
                                | .{{normalFee | fmtFee(1)}}
                        .fr 支付
                            span.color.Akrobat-ExtraBold ￥
                                span.big {{orderInfo.amount | fmtFee}}
                                | .{{orderInfo.amount | fmtFee(1)}}

                .pay
                    | 账号支付密码
                    .pswd-box
                        .no-click-cover
                        .input(type="password" @click="inputClick")
                            .box(v-for="(item, i) in 6" :class="{'cur': pwdInputIdx == i}")
                                input(
                                    ref="payInput"
                                    v-model="password[i]"
                                    @focus="pwdInputIdx = i"
                                    @keydown="(e) => { pwdChange(e, i) }"
                                    type="password"
                                )
                                .line(v-if="i<5")
                        .pswd-btm 输入6位数字密码
                            .fr(@click="goUrl('/modifyPassword', { type: 2 })") 忘记密码

                .submit-btn(@click="payAction") 确认付款

        fix-center.fix-recharge(ref="recharge" w="400" h="300")
            template(slot="title") 温馨提醒
            .c(slot="main")
                img(src="../../assets/icon-fee-short.png")
                div 您的支付余额不足，快去充值~
            template(slot="btm")
                .fix-btn.red(@click="goUrl('/recharge')") 去充值
                .fix-btn(@click="$refs.recharge.hide()") 取消

        fix-center.fix-recharge(ref="setPwd" w="400" h="300")
            template(slot="title") 温馨提醒
            .c(slot="main")
                img(src="../../assets/icon-fee-short.png")
                div 您还未设置支付密码，请设置后再支付订单
            template(slot="btm")
                .fix-btn.red(@click="goUrl('/modifyPassword', { type: 2, payRedirect: '/orderPay', orderId: $route.query.id })") 前往设置
                .fix-btn(@click="$refs.setPwd.hide()") 取消
            
</template>

<script>
import { mapGetters } from 'vuex'
import { getOrderDetail, orderPayment } from "@/utils/api"

export default {
    name: 'OrderPay',
    data(){
        let query = this.$route.query
        return {
            useFree: query.freeMark && query.freeMark == 1, // 是否使用会员权益支付
            amount: 0,
            password: [],
            pwdInputIdx: 0,
            leftSeconds: 30 * 60 - 1,
            isPaying: false,
            timeInterval: null,
            orderFrom: this.$route.query.from || 'map',
            pageTitle: this.orderFrom === 'map' ? '地图投放' : '智能快速发布',
            orderInfo: {}
        }
    },
    computed: {
        leftTime () {
            let time = this.leftSeconds
            let h = Math.floor(time / 3600)
            let m = Math.floor(time % 3600 / 60)
            let s = time % 60
            return add0(h) + '时' + add0(m) + '分' + add0(s) + '秒'
            function add0 (t) {
                return t - 0 < 10 ? '0' + t : t
            }
            // let s = time % 60 > 9 ? time % 60 : '0'+ time % 60
            // return Math.floor(time / 60) + '分' + s + '秒'
        },
        ...mapGetters('customer', {
            vipPointRemain: 'vipFreeRemain',
            normalFee: 'normalFee', // 普通账户总余额
            hasPayPwd: 'hasPayPwd',
        })
    },
    beforeDestroy () {
        window.clearInterval(this.timeInterval)
        document.body.removeEventListener('click', this.inputFocus, false)
    },
    watch: {
        hasPayPwd: {
            immediate: true,
            handler (v) {
                this.$nextTick(() => {
                    let refPwd = this.$refs.setPwd
                    if (refPwd) {
                        if (!v) refPwd.show()
                        else refPwd.hide()
                    }
                })
            }
        }
    },
    async created() {
        // 会员权益
        this.$store.dispatch('order/getPayWay')
        // 订单信息以及倒计时相关数据
        let data = await getOrderDetail({guid: this.$route.query.id})
        if (data && data.code == this.successCode && data.data) {
            let obj = data.data
            this.orderInfo = obj
            this.leftSeconds = obj.valiPeriodSec || 0
        } else {
            this.messageTip(data && data.msg || '获取订单信息异常，请稍后刷新重试')
        }
        // 账户余额
        await this.$store.dispatch('customer/getAccBalance')
    },
    mounted () {
        this.timeInterval = setInterval(()=>{
            if (this.leftSeconds > 0) {
                this.leftSeconds--
            } else {
                clearInterval(this.timeInterval)
                this.goUrl('/orderList')
            }
        }, 1000)
        window.onkeydown = (e) => {
            let code = e.keyCode || e.which
            if(code == 8) {   // 删除
                if(this.pwdInputIdx > 0){
                    this.pwdInputIdx--
                    this.$nextTick(() => {
                        if (this.$refs.payInput[this.pwdInputIdx]) this.$refs.payInput[this.pwdInputIdx].focus()
                    })
                }
            }
        }

        this.$nextTick(() => {
            const to = setTimeout(() => {
                clearTimeout(to)
                if (this.$route.path == '/orderPay') {
                    this.pwdInputIdx = 0
                    this.$nextTick(() => { this.$refs.payInput[this.pwdInputIdx].focus() })
                    document.body.addEventListener('click', this.inputFocus, false)
                }
                this.handleshowCharge()
            }, 400)
        })
    },
    methods: {
        handleshowCharge () {
            if (this.normalFee - this.orderInfo.amount < 0) { // 余额不足
                this.$refs.recharge.show()
                return true
            }
            return false
        },
        inputFocus () {
            this.$refs.payInput[this.pwdInputIdx].focus()
        },
        inputClick () {
            // this.pwdInputIdx = 0
            // this.$refs.payInput[this.pwdInputIdx].focus()
        },
        pwdChange (e, i) {
            let code = e.keyCode || e.which
            if ((code >= 48 && code <= 57) || code == 8 || (code >= 96 && code <= 105)) {
                this.$set(this.password, i, '')
                e.target.value = ''
                const st = setTimeout(() => {
                    clearTimeout(st)
                    if (code == 8) {
                        if(e.target.value != '') this.$refs.payInput[i-1] && this.$refs.payInput[i-1].focus()
                    } else {
                        this.$refs.payInput[i+1] && this.$refs.payInput[i+1].focus()
                    }
                }, 20)
            } else {
                if (e && e.stopPropagation) e.preventDefault()
                else window.event.returnValue = false
            }
        },
        async payAction () {
            if (this.password.filter(el => el).length == 0) return this.messageTip('请输入支付密码')
            else if (this.password.filter(el => el).length < 6) return this.messageTip('支付密码不正确')
            if (this.handleshowCharge()) return
            if (this.isPaying) return
            this.isPaying = true
            // 更新用户数据
            if (!this.hasPayPwd) await this.$store.dispatch('customer/getUserInfo')
            this.$nextTick(async () => {
                if(!this.hasPayPwd) { // 未设置支付密码
                    this.$refs.setPwd.show()
                    this.isPaying = false
                    return
                }

                const param = await this.encryptorProto({ payPassword: this.password.join('') })
                if (param) {
                    const res = await orderPayment(this.orderInfo.guid, param)
                    this.isPaying = false
                    if (res) {
                        if (res.code == this.successCode) {
                            tzx_czcPush('payOrder', 1)
                            this.$store.dispatch('orderSum', { orderStatusList: '3,4' }) // 更新导航上部点位数
                            this.$store.dispatch('customer/getAccBalance') // 更新余额
                            this.$store.dispatch('customer/getCustomerInfo') // 更新客户信息中的会员限免点位额度
                            this.$store.dispatch('order/getPayWay') // 更新会员权益
                            this.goUrl('/payOk', { orderId: this.orderInfo.guid, from: this.orderFrom, isPkg: this.$route.query.isPkg || '' })
                        } else if (res.code == 90003003) { // 余额不足
                            tzx_czcPush('payOrder', 0)
                            this.$refs.recharge.show()
                        }
                    } else {
                        tzx_czcPush('payOrder', 0)
                        this.messageTip(res.msg || '操作失败')
                    }
                } else {
                    this.isPaying = false
                }
            })
        }
    }
}
</script>


